import { Button } from "@/components/ui/button";
import { Sun, Warning } from "@phosphor-icons/react";

export function TrialBanner({ daysLeft, onUpgrade }) {
  const urgent = daysLeft <= 3;
  return (
    <div
      data-testid="trial-banner"
      className={`flex flex-col items-start gap-3 rounded-xl border p-4 sm:flex-row sm:items-center sm:justify-between ${
        urgent ? "border-[#E06D53]/40 bg-gradient-to-r from-[#FFE8D6] to-[#FFD9B8]" : "border-[#F2B24C]/50 bg-gradient-to-r from-[#FFF4D6] via-[#FFE9C2] to-[#FFDDB5]"
      }`}
    >
      <div className="flex items-start gap-3">
        <span className={urgent ? "text-[#C2502F]" : "text-[#E8834F]"}>
          {urgent ? <Warning size={22} weight="duotone" /> : <Sun size={24} weight="fill" />}
        </span>
        <div>
          <p className="font-medium text-[#2C2A28]">
            {daysLeft > 0
              ? `${daysLeft} day${daysLeft === 1 ? "" : "s"} left in your free trial`
              : "Your free trial ends today"}
          </p>
          <p className="text-sm text-[#8A7F76]">
            {urgent
              ? "When it ends, your memories will be permanently deleted. Join to keep them forever."
              : "You're exploring the free Childhood season. Join anytime to unlock every season."}
          </p>
        </div>
      </div>
      <Button
        data-testid="banner-upgrade-btn"
        onClick={onUpgrade}
        className="rounded-full bg-[#E06D53] font-semibold text-white shadow-md shadow-[#E06D53]/25 hover:-translate-y-0.5 hover:bg-[#C85B43]"
      >
        Get Lifetime Access
      </Button>
    </div>
  );
}
